import React from 'react'
import CommonSectionCategory from '../../../Shared/CommonSectionCategory';
import { categoryModel } from '../../../Model/categoryCons';

const ChildrenBooksCategory = () => {
    return (
        <>
            <CommonSectionCategory props={categoryModel.ChildrenBooks} />
        </>
    )
}

export default ChildrenBooksCategory;